<template>
  <ul class="flex space-x-5">
    <template v-for="(social, key) in socialList" :key="key">
      <li v-if="getAuthSocialUrl(social.type)">
        <UiButton
          icon
          class="block"
          :class="[
            socialStyle[social.type as keyof typeof socialStyle].color,
            socialStyle[social.type as keyof typeof socialStyle].button
          ]"
          @click="onSocialClick(social)"
        >
          <UiIcon
            class="mx-auto"
            :class="socialStyle[social.type as keyof typeof socialStyle].iconClass"
            :name="`img/icon-${social.type}`"
          />
        </UiButton>
      </li>
    </template>
  </ul>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import type { LayoutAuthSocials } from '@/models'

const props = defineProps({
  size: {
    type: String as PropType<'modal' | 'page'>,
    default: 'modal',
  },
})

const { getAuthSocialUrl } = useLayoutStore()

const { socialList } = storeToRefs(useLayoutStore())

const socialStyle = {
  vkontakte: {
    button:
      props.size === 'page'
        ? 'h-12 w-12 rounded-xl !pt-2.5 md:h-8 md:w-8 md:rounded-lg md:!pt-2.5'
        : 'h-8 w-8 rounded-lg !pt-2.5',
    color: 'bg-[#0077FF] !px-0 hover:!bg-[#0077FF] active:!bg-[#0077FF]',
    iconClass:
      props.size === 'page'
        ? 'h-[0.935rem] w-[1.5rem] md:h-[0.83rem] md:w-[1.33rem]'
        : 'h-[0.83rem] w-[1.33rem]',
  },
  alfabank_id: {
    button:
      props.size === 'page'
        ? 'h-12 w-12 rounded-xl !pt-2 md:h-8 md:w-8 md:rounded-lg md:!pt-2'
        : 'h-8 w-8 rounded-lg !pt-2',
    color: 'bg-[#EF3124] !px-0 hover:!bg-[#EF3124] active:!bg-[#EF3124]',
    iconClass:
      props.size === 'page'
        ? 'h-[1.5rem] w-[1.5rem] md:h-[1rem] md:w-[1.33rem]'
        : 'h-[1.1rem] w-[1.33rem]',
  },
  odnoklassniki: {
    button:
      props.size === 'page'
        ? 'h-12 w-12 rounded-xl !pt-3 md:h-8 md:w-8 md:rounded-lg md:!pt-1'
        : 'h-8 w-8 rounded-lg !pt-1',
    color: 'bg-[#F7931E] !px-0 hover:!bg-[#F7931E] active:!bg-[#F7931E]',
    iconClass:
      props.size === 'page'
        ? 'h-[1.52rem] w-[0.9rem] md:h-[1.4rem] md:w-[0.84rem]'
        : 'h-[1.4rem] w-[0.84rem]',
  },
}

const { openWindow } = useExternalWindow()
const { socialLogin } = useAuthStore()
const { errors } = storeToRefs(useAuthStore())
const { closeModal } = useModalStore()

const pagesForRedirect = ['user-login', 'user-registration']

const navigateAfterLogin = async () => {
  const { name } = useRoute()

  if (!pagesForRedirect.includes(name as string)) return

  if (!errors.value.socialLogin.length && !errors.value.currentUser.length) {
    await navigateTo('/user/profile')
  } else {
    await navigateTo('/user/login')
  }
}

const onSocialClick = (social: LayoutAuthSocials) => {
  const url = getAuthSocialUrl(social.type)

  if (!url) return

  openWindow(url, social.type, async (event: MessageEvent) => {
    const { data } = event

    await socialLogin(data)

    closeModal('authenticationAttemptFormModal')

    await navigateAfterLogin()
  })
}
</script>
